/**
 * Eros PLP filter tray (ADR-205) - LAZY DATA FETCHES (network + sessionStorage). No rendering.
 * The tray asks for these only once it is opened; each result is cached for the session.
 *
 *   loadPrices(state, data, done)       the collection's own prices (price terciles)
 *   loadIngredients(state, data, done)  metaobject id -> { canonical_id, name_en, category }
 *                                       (sections/eros-plp-ingredient-index.liquid)
 *
 * `state` is the entry's module state; this file only touches the four fields named below:
 *   prices{handle:[n]}, pricesRequested{handle:true}, ingredients{id:{c,e,k}}|null, ingredientsRequested.
 */
(function (root) {
  'use strict';
  var ns = (root.ErosPlpTray = root.ErosPlpTray || {});

  var PRICE_CACHE_PREFIX = 'eros_tray_prices_v1:';
  var ING_CACHE_KEY = 'eros_tray_ingredients_v1';
  var ING_SECTION = 'eros-plp-ingredient-index';
  var ING_MAX_PAGES = 6; /* 250 ingredients per page; the catalog is ~260 */

  function shopRoot() {
    return (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
  }

  /* ---- price source: the collection's own prices (cached per handle) ------------------ */
  function loadPrices(state, data, done) {
    var key = data.handle;
    if (!key || data.kind !== 'collection' || state.pricesRequested[key]) return;
    state.pricesRequested[key] = true;
    try {
      var cached = sessionStorage.getItem(PRICE_CACHE_PREFIX + key);
      if (cached) {
        state.prices[key] = JSON.parse(cached);
        done();
        return;
      }
    } catch (e) {
      /* storage can be blocked */
    }
    fetch(shopRoot() + 'collections/' + encodeURIComponent(key) + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (json) {
        var list = ns.price.pricesFromProductsJson(json);
        if (!list.length) return;
        state.prices[key] = list;
        try {
          sessionStorage.setItem(PRICE_CACHE_PREFIX + key, JSON.stringify(list));
        } catch (e) {
          /* ignore */
        }
        done();
      })
      .catch(function () {});
  }

  /* ---- ingredient index: GID -> canonical_id / name_en / category ----------------------- */
  function readIndexPage(html) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-eros-ingredient-index]');
    try {
      return node ? JSON.parse(node.textContent) : null;
    } catch (e) {
      return null;
    }
  }

  function loadIngredients(state, data, done) {
    if (state.ingredientsRequested || !ns.logic.findFilter(data.filters, ns.logic.ROW_PARAM.actives)) return;
    state.ingredientsRequested = true;
    try {
      var cached = sessionStorage.getItem(ING_CACHE_KEY);
      if (cached) {
        state.ingredients = JSON.parse(cached);
        done();
        return;
      }
    } catch (e) {
      /* storage can be blocked */
    }
    var lookup = {};
    function fetchPage(url, n) {
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          return r.ok ? r.text() : null;
        })
        .then(function (html) {
          var page = html ? readIndexPage(html) : null;
          if (!page) {
            state.ingredientsRequested = false; /* retry on the next open */
            return;
          }
          ns.actives.mergeIndex(lookup, page);
          if (page.next && n < ING_MAX_PAGES) {
            /* follow the real "next" link: paginate namespaces its page param per instance */
            var u = new URL(page.next, location.origin);
            u.searchParams.set('section_id', ING_SECTION);
            fetchPage(u.toString(), n + 1);
            return;
          }
          state.ingredients = lookup;
          try {
            sessionStorage.setItem(ING_CACHE_KEY, JSON.stringify(lookup));
          } catch (e) {
            /* ignore */
          }
          done();
        })
        .catch(function () {
          state.ingredientsRequested = false;
        });
    }
    fetchPage(shopRoot() + '?section_id=' + ING_SECTION, 1);
  }

  ns.data = { loadPrices: loadPrices, loadIngredients: loadIngredients };
})(typeof window !== 'undefined' ? window : globalThis);
